import React from 'react'
import { Link } from 'react-router-dom'
import { Anchor } from 'components'
import { isSpaRoute } from 'utils/isSpaRoute'
import { useStyles } from './TextLinkStyles'

interface TextLinkProps {
  children: React.ReactNode
  iconLeft?: React.ReactElement
  iconRight?: React.ReactElement
  href?: string
  fullWidth?: boolean
  disabled?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  onClick?: () => void
  inline?: boolean
  style?: React.CSSProperties
}

export const TextLink = ({
  href,
  children,
  iconLeft,
  iconRight,
  fullWidth,
  disabled,
  size,
  onClick,
  inline,
  ...props
}: TextLinkProps) => {
  const { classes } = useStyles({ fullWidth, disabled, inline })

  const content = (
    <>
      {iconLeft && React.cloneElement(iconLeft, { className: classes.iconLeft })}
      {children}
      {iconRight && React.cloneElement(iconRight, { className: classes.iconRight })}
    </>
  )

  // SPA destinations navigate through react-router so the persistent Arc
  // shell survives; native anchor semantics (cmd/ctrl/middle click) are kept
  if (!onClick && href && isSpaRoute(href)) {
    return (
      <Anchor {...props} size={size} component={Link} to={href} className={classes.anchor}>
        {content}
      </Anchor>
    )
  }

  const component = onClick ? 'button' : 'a'

  return (
    <Anchor {...props} size={size} component={component} href={href} onClick={onClick} className={classes.anchor}>
      {content}
    </Anchor>
  )
}
